export default __webpack_public_path__ + "static/media/smart.f265e60d.jpg";